(function(){
  var PHRASE={'deep lake':'#2E5D68','fig green':'#5F7350','total black':'#1F1D1A','total ivory':'#F3EEE2','mustard black':['#C99A3C','#1F1D1A'],'ivory black':['#F3EEE2','#1F1D1A'],'ivory fuchsia':['#F3EEE2','#D5379F'],'ivory green':['#F3EEE2','#5F7350'],'dark grey':'#4A4742','dark blue':'#1F3A5C','navy blue':'#22304A','light gray':'#C8C4BC','light grey':'#C8C4BC','light green':'#A8C0A0','military green':'#5A6248','neon green':'#7ED321','neon orange':'#FF8C1A','neon pink':'#FF4FA3','winter blue':'#7FA6C9','ocean blue':'#2E6E8E','pacific blue':'#2E6E8E','moonlit':'#6B7A99','granite':'#8C8C8C','onyx':'#1F1D1A','slate':'#5C6670','garnet':'#7A2E3A','forest':'#3E5C46','sapphire':'#3355A8','jade':'#3E8E6E','clover':'#4E8E4E','lava':'#C0452E','cobalt':'#1F4EA8','mahogany':'#6E3A2E','poseidon':'#2E5D8E','neptune':'#3A6E8E','harvest':'#C08A3C','solar':'#E0A83C','midnight':'#232A3E','fern':'#5F7350','mint':'#9ED9C0','celestine':'#9EC0D9','ocean':'#33718F','loon':'#4A5560','reflection':'#7A99A8','tropical':'#2EA86E','verdure':'#4E8E5C','botanical':'#6E8E4E','peppermint':'#8EDBC5'};
  var TOKEN={black:'#1F1D1A',white:'#FFFFFF',ivory:'#F3EEE2',gray:'#9A968E',grey:'#9A968E',pink:'#E86FA4',fuchsia:'#D5379F',blue:'#3E6C9E',orange:'#D97C2B',green:'#5F7350',mustard:'#C99A3C',red:'#B3402E',purple:'#7A5C8A',brown:'#7A5B41',beige:'#D9CBB4',yellow:'#D9B23C',navy:'#22304A',cream:'#F1E8D8',coffee:'#5C4433'};
  function colorsFor(name){
    var n=name.toLowerCase().replace(/\(.*?\)/g,'').replace(/\s+/g,' ').trim();
    if(PHRASE[n]){var p=PHRASE[n];return Array.isArray(p)?p:[p];}
    var out=[];
    n.split(/[\s\/]+/).forEach(function(t){if(PHRASE[t]&&out.length<2){var q=PHRASE[t];out.push(Array.isArray(q)?q[0]:q);}else if(TOKEN[t]&&out.length<2){out.push(TOKEN[t]);}});
    return out;
  }
  function paint(el,cols){el.style.background=cols.length>1?('linear-gradient(135deg,'+cols[0]+' 50%,'+cols[1]+' 50%)'):cols[0];}
  function isColorFilter(el){
    var s=el.querySelector('summary, .facets__summary, .mobile-facets__summary');
    var t=(s?s.textContent:'')||'';
    return t.toLowerCase().indexOf('color')!==-1;
  }
  function decorateFilters(){
    document.querySelectorAll('.js-filter, .mobile-facets__details').forEach(function(f){
      if(!isColorFilter(f))return;
      f.querySelectorAll('label.facet-checkbox, label.mobile-facets__label').forEach(function(lb){
        if(lb.querySelector('.gf-swatch'))return;
        var txtEl=lb.querySelector('.facet-checkbox__text, .mobile-facets__label-text')||lb;
        var cols=colorsFor((txtEl.textContent||'').trim());
        if(!cols.length)return;
        var s=document.createElement('span');
        s.className='gf-swatch';
        paint(s,cols);
        if(txtEl===lb){lb.insertBefore(s,lb.firstChild);}else{txtEl.parentNode.insertBefore(s,txtEl);}
      });
    });
  }
  function decorateCards(){
    document.querySelectorAll('.card-wrapper').forEach(function(card){
      if(card.dataset.gfSwatched)return;
      var cont=card.querySelector('.card__swatches-container');
      if(!cont)return;
      var swatches=cont.querySelectorAll('.color-swatch');
      if(!swatches.length)return;
      var order=null;
      var sc=card.querySelector('card-variant-selects script[type="application/json"]');
      if(sc){
        try{
          var variants=JSON.parse(sc.textContent);
          for(var pos=1;pos<=3;pos++){
            var seen=[];
            variants.forEach(function(v){var val=v['option'+pos];if(val&&seen.indexOf(val)===-1)seen.push(val);});
            var allColored=seen.length===swatches.length&&seen.length>0;
            if(allColored){for(var i=0;i<seen.length;i++){if(!colorsFor(seen[i]).length){allColored=false;break;}}}
            if(allColored){order=seen;break;}
          }
        }catch(e){}
      }
      if(!order&&swatches.length===1){
        var h=card.querySelector('.card__heading a');
        if(h){var parts=h.textContent.split('—');if(parts.length>1){order=[parts[parts.length-1].trim()];}}
      }
      if(!order)return;
      swatches.forEach(function(sw,i){
        var name=order[i];if(!name)return;
        var cols=colorsFor(name);if(!cols.length)return;
        var dot=sw.querySelector('.color-swatch__custom-color');
        if(dot)paint(dot,cols);
        if(sw.classList.contains('hidden')){
          sw.classList.remove('hidden');
          var inp=sw.querySelector('input');if(inp)inp.value=name;
          var lb=sw.querySelector('.color-swatch__label');if(lb)lb.textContent=name;
        }
      });
      card.dataset.gfSwatched='1';
    });
  }
  function layoutFacets(){
    var form=document.querySelector('facet-filters-form.facets form.facets__form');
    if(!form||form.querySelector('.gf-facets-head'))return;
    var wrap=form.querySelector('.facets__wrapper');
    var sort=form.querySelector('.facet-filters.sorting');
    var count=form.querySelector('.product-count');
    if(!wrap||!sort||!count)return;
    var head=document.createElement('div');
    head.className='gf-facets-head';
    var title=document.createElement('div');
    title.className='gf-facets-title';
    title.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><circle cx="9" cy="7" r="2.6" fill="#FFFFFF"/><line x1="4" y1="16" x2="20" y2="16"/><circle cx="15" cy="16" r="2.6" fill="#FFFFFF"/></svg><span>Filters</span>';
    head.appendChild(title);
    var right=document.createElement('div');
    right.className='gf-facets-head-right';
    right.appendChild(sort);
    right.appendChild(count);
    head.appendChild(right);
    form.insertBefore(head,form.firstChild);
  }
  /* ---- Product page: WOMEN/MEN toggle + US size pills ---- */
  var GF_RX=/^W([\d.\-]+)\s*\/\s*M([\d.\-]+)$/;
  var SOCK_RX=/^(XS|S|M|L|XL|XXL)\s*\(EU\s*[\d.]+(?:\s*[-–]\s*[\d.]+)?\+?\)$/;
  var US_RX=/^US\s*([\d.]+)(?:\s*\|\s*EU\s*[\d.]+)?$/;
  var SOCKMAP={XS:{W:'4.5-5.5',M:'3-4'},S:{W:'6-8.5',M:'4.5-7'},M:{W:'9-11.5',M:'7.5-10'},L:{W:'12-14.5',M:'10.5-13'},XL:{W:'15+',M:'13.5+'},XXL:{W:'15.5+',M:'14+'}};
  var SOCKNUM={S:{W:[6,8.5],M:[4.5,7]},M:{W:[9,11.5],M:[7.5,10]},L:{W:[12,14.5],M:[10.5,13]},XL:{W:[15,20],M:[13.5,20]},XS:{W:[4.5,5.5],M:[3,4]},XXL:{W:[15.5,20],M:[14,20]}};
  var gfsp={gender:'W',sel:null,box:null,mode:'shoe'};
  function sockLetter(v){var m=v.match(SOCK_RX);return m?m[1]:null;}
  function gfLabel(v,g){
    var m=v.match(GF_RX);
    if(m)return 'US '+(g==='W'?m[1]:m[2]);
    var u=v.match(US_RX);
    if(u)return 'US '+u[1];
    var L=sockLetter(v);
    if(L&&SOCKMAP[L])return L+' · US '+SOCKMAP[L][g==='M'?'M':'W'];
    return v;
  }
  function gfRender(){
    if(!gfsp.box||!gfsp.sel)return;
    var pills=gfsp.box.querySelector('.gfsp__pills');
    pills.innerHTML='';
    var opts=[].slice.call(gfsp.sel.options);
    if(gfsp.mode==='us'){opts.sort(function(a,b){var x=a.value.match(US_RX),y=b.value.match(US_RX);return parseFloat(x?x[1]:0)-parseFloat(y?y[1]:0);});}
    opts.forEach(function(o){
      var b=document.createElement('button');
      b.type='button';
      b.textContent=gfLabel(o.value,gfsp.gender);
      if(o.disabled)b.disabled=true;
      if(gfsp.sel.value===o.value)b.classList.add('active');
      b.addEventListener('click',function(){
        gfsp.sel.value=o.value;
        gfsp.sel.dispatchEvent(new Event('change',{bubbles:true}));
        gfRender();
      });
      pills.appendChild(b);
    });
    if(gfsp.mode==='sock'){pills.style.gridTemplateColumns='repeat(2,1fr)';}
    var wb=gfsp.box.querySelector('[data-g="W"]'),mb=gfsp.box.querySelector('[data-g="M"]');
    if(wb){wb.classList.toggle('active',gfsp.gender==='W');}
    if(mb){mb.classList.toggle('active',gfsp.gender==='M');}
  }
  function gfSizePicker(){
    if(document.querySelector('.gfsp'))return;
    var sel=null,mode='shoe';
    document.querySelectorAll('.product__info-container select').forEach(function(s){
      if(sel)return;
      var opts=[].map.call(s.options,function(o){return o.value;});
      if(!opts.length)return;
      if(opts.every(function(v){return GF_RX.test(v);})){sel=s;mode='shoe';}
      else if(opts.every(function(v){return SOCK_RX.test(v);})){sel=s;mode='sock';}
      else if(opts.every(function(v){return US_RX.test(v);})){sel=s;mode='us';}
    });
    if(!sel)return;
    gfsp.sel=sel;gfsp.mode=mode;
    var wrap=sel.closest('.product-form__input')||sel.parentElement;
    var box=document.createElement('div');
    box.className='gfsp';
    box.innerHTML='<div class="gfsp__head"><span class="gfsp__title">Select size (US)</span><span class="gfsp__toggle"><button type="button" data-g="W">WOMEN</button><button type="button" data-g="M">MEN</button></span></div><div class="gfsp__pills"></div>';
    box.querySelectorAll('.gfsp__toggle button').forEach(function(b){
      b.addEventListener('click',function(){gfsp.gender=b.dataset.g;gfRender();});
    });
    if(mode==='us'){var tog=box.querySelector('.gfsp__toggle');if(tog)tog.style.display='none';}
    gfsp.box=box;
    wrap.parentNode.insertBefore(box,wrap);
    wrap.style.display='none';
    var lbl=document.querySelector('.product__info-container .form__label');
    gfRender();
  }
  window.gfApplySize=function(g,size){
    if(!gfsp.sel)return false;
    gfsp.gender=(g==='M')?'M':'W';
    var found=null;
    if(gfsp.mode==='sock'){
      var num=parseFloat(size);var gg=gfsp.gender;
      var pick=null;
      ['XS','S','M','L','XL','XXL'].forEach(function(L){
        if(pick||!SOCKNUM[L])return;
        if(num<=SOCKNUM[L][gg][1])pick=L;
      });
      if(!pick)pick='XL';
      [].forEach.call(gfsp.sel.options,function(o){
        if(found)return;
        if(sockLetter(o.value)===pick&&!o.disabled)found=o;
      });
    }else if(gfsp.mode==='us'){
      [].forEach.call(gfsp.sel.options,function(o){
        if(found)return;
        var u=o.value.match(US_RX);
        if(u&&parseFloat(u[1])===parseFloat(size)&&!o.disabled)found=o;
      });
    }else{
      var target='US '+size;
      [].forEach.call(gfsp.sel.options,function(o){
        if(found)return;
        if(gfLabel(o.value,gfsp.gender)===target&&!o.disabled)found=o;
      });
    }
    if(found){gfsp.sel.value=found.value;gfsp.sel.dispatchEvent(new Event('change',{bubbles:true}));}
    gfRender();
    return !!found;
  };
  function decorate(){layoutFacets();decorateFilters();decorateCards();gfSizePicker();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',decorate);}else{decorate();}
  var t;
  new MutationObserver(function(){clearTimeout(t);t=setTimeout(decorate,150);}).observe(document.documentElement,{childList:true,subtree:true});
})();
